import { ReactNode } from "react";
import { useHistory } from "react-router-dom";
import { useOnboardingState } from "./OnboardingDataContext";
import { OnboardingStepper } from "./OnboardingStepper";
import { InvitedDetailsStep } from "./steps/InvitedDetailsStep/InvitedDetailsStep";
import { PhoneStep } from "./steps/PhoneStep/PhoneStep";
import { INVITED_STEP_CONFIG, ONBOARDING_STEP, StepId } from "./types";

export const InvitedSignupContent = () => {
  const history = useHistory();
  const onboarding = useOnboardingState();

  const renderStepBody = (id: StepId): ReactNode => {
    if (id === ONBOARDING_STEP.PERSONAL_DETAILS) {
      return (
        <InvitedDetailsStep
          onComplete={(summary) => onboarding.completeStep(id, summary)}
        />
      );
    }

    if (id === ONBOARDING_STEP.PHONE) {
      const handlePhoneComplete = (summary: ReactNode) => {
        onboarding.completeStep(id, summary);
        history.replace("/");
      };

      return <PhoneStep onComplete={handlePhoneComplete} />;
    }

    return null;
  };

  return (
    <OnboardingStepper
      onboarding={onboarding}
      steps={INVITED_STEP_CONFIG}
      renderStepBody={renderStepBody}
    />
  );
};
